<template>
    <div class="w-full space-y-3">
        <Head title="Reports"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Client Details List</h1>
            <a :href="route('frontend.reports.finance_client_details_list_export', {
                _query: {
                    has_cmid: form.has_cmid,
                    has_smid: form.has_smid,
                    search: form.search,
                    trading_entity: form.trading_entity
                }})" class="py-3 px-3 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amaze-coral w-40 text-center">Download</a>
        </div>
    </div>
    <br />
    <div class="grid grid-cols-4 gap-2">
        <div class="relative" v-if="trading_details.length > 1">
            <label for="trading-entity" class="block text-sm font-medium text-gray-700">Trading Entity</label>
            <select id="trading-entity" v-model="form.trading_entity"
                class="mt-1 block w-full bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                <option value="" v-html="'All'"></option>
                <option v-for="(trading_detail, index) in trading_details" :key="index" :value="trading_detail.id" :selected="form.trading_entity === trading_detail.id" v-html="trading_detail.trading_name"></option>
            </select>
        </div>
        <div class="relative">
            <label for="has_cmid" class="block text-sm font-medium text-gray-700">Has CMID?</label>
            <select id="has_cmid" v-model="form.has_cmid"
                class="mt-1 block w-full bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                <option value="Yes" v-html="'Yes'"></option>
                <option value="No" v-html="'No'"></option>
            </select>
        </div>
        <div class="relative">
            <label for="has_cmid" class="block text-sm font-medium text-gray-700">Has SMID?</label>
            <select id="has_cmid" v-model="form.has_smid"
                class="mt-1 block w-full bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                <option value="Yes" v-html="'Yes'"></option>
                <option value="No" v-html="'No'"></option>
            </select>
        </div>
        <div class="relative mt-2">
            <search-filter :show-filter="false" v-model:value="form.search" class="w-full pt-4" name="search" @reset="reset"></search-filter>
        </div>
    </div>
    <br />
    <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
        <div class="flex flex-col mt-3 space-y-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Name
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Registered Legal Name
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Organisation Type
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        CMID Number
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        SMID Number
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Payment Terms
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        VAT ID
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Address
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Organisation Address
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Tax & Billing Address
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="Object.values(clients).length > 0" v-for="(client, index) in clients.data" :key="index">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.organisations.clients.organisation.show' , client.id)">
                                            {{ client.name }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.organisations.clients.organisation.show' , client.id)">
                                            {{ client.registered_legal_name }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ client.type.charAt(0).toUpperCase() + client.type.slice(1) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ client.cmid }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ client.smid }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ client.payment_terms }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ client.tax?.vat_id ?? '' }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <span v-if="client.address?.street">{{ client.address.street }}, </span>
                                        <span v-if="client.address?.address_line_1">{{ client.address.address_line_1 }}, </span>
                                        <span v-if="client.address?.address_line_2">{{ client.address.address_line_2 }}, </span>
                                        <span v-if="client.address?.address_line_3">{{ client.address.address_line_3 }}, </span>
                                        <span v-if="client.address?.city">{{ client.address.city }}, </span>
                                        <span v-if="client.address?.code">{{ client.address.code }} </span>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <span v-if="client.address?.street">{{ client.address.street }}, </span>
                                        <span v-if="client.address?.address_line_1">{{ client.address.address_line_1 }}, </span>
                                        <span v-if="client.address?.address_line_2">{{ client.address.address_line_2 }}, </span>
                                        <span v-if="client.address?.address_line_3">{{ client.address.address_line_3 }}, </span>
                                        <span v-if="client.address?.city">{{ client.address.city }}, </span>
                                        <span v-if="client.address?.code">{{ client.address.code }} </span>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <span v-if="client.tax?.address?.street">{{ client.address.street }}, </span>
                                        <span v-if="client.tax?.address?.address_line_1">{{ client.address.address_line_1 }}, </span>
                                        <span v-if="client.tax?.address?.address_line_2">{{ client.address.address_line_2 }}, </span>
                                        <span v-if="client.tax?.address?.address_line_3">{{ client.address.address_line_3 }}, </span>
                                        <span v-if="client.tax?.address?.city">{{ client.address.city }}, </span>
                                        <span v-if="client.tax?.address?.code">{{ client.address.code }} </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Pagination :links="clients.links"/>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import pickBy from "lodash/pickBy";
    import debounce from "lodash/debounce";
    import mapValues from "lodash/mapValues";
    import {Link, Head} from "@inertiajs/vue3";
    import Pagination from "@/Components/Pagination";
    import Authenticated from "@/Layouts/Authenticated";
    import SearchFilter from "@/Components/SearchFilter";

    export default {
        layout: Authenticated,
        components: {
            Head,
            Link,
            Pagination,
            SearchFilter
        },
        props: ['clients', 'has_cmid', 'has_smid', 'search', 'trading_details'],
        created() {
            this.moment = moment
        },
        data(props) {
            return {
                form: {
                    has_cmid: props.has_cmid,
                    has_smid: props.has_smid,
                    search: this.search ?? null,
                    trading_entity: null
                }
            }
        },
        methods: {
            reset() {
                this.form = mapValues(this.form, () => null)
            }
        },
        watch: {
            form: {
                deep: true,
                handler: debounce(function () {
                    this.$inertia.get(route('frontend.reports.finance_client_details_list'), pickBy(this.form), {preserveState: true, preserveScroll: true})
                }, 500),
            },
        }
    }
</script>
